<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-ministry-sidebar></app-ministry-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div class="card shadow m-3" style="width: 100%">
              <div
                class="
                  card-header
                  heading_n_button_box
                  card-header-cus-new-appoint
                  card-header-responsive
                "
              >
                <div class="card-heading">
                  <h4>List of Passengers with Forged Results</h4>
                </div>

                <div class="button-section mt-1"></div>
              </div>

              <div class="card-body">
                <div class="col-lg-12">
                  <div class="col-lg-12">
                    <form
                      [formGroup]="searchForm"
                      (ngSubmit)="onSubmitSearch(searchForm.value)"
                    >
                      <div class="form-row">
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="passengerName" placeholder="Passenger Name"
                            formControlName="passengerName"
                            id="passengerName"
                          > 
                        </div> 
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="passportNumber" placeholder="Passport Number"
                            formControlName="passportNumber"
                            id="passportNumber"
                          > 
                        </div> 
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="phone" placeholder="Phone Number"
                            formControlName="phone"
                            id="phone"
                          > 
                        </div> 
 

                        <div class="col">
                          <div class="mr-4">
                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                              "
                              type="submit"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fas fa-search"></i> Search
                            </button>

                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                                ml-2
                              "
                              type="button"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                              (click)="clearSearch()"
                            >
                              <i class="fas fa-sync-alt"></i> Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="row">
                    <div class="table-responsive mt-3">
                      <div class="col-auto">
                        <div class="row" *ngIf="forgedresults!=''">
                          <div class="show-record mt-3 mbm-32">
                            <span>Show</span> &nbsp;
                            <select
                              class="
                                custom-select custom-select-sm
                                form-control form-control-sm
                              "
                              (change)="setItemsPerPage(page.value)"
                              #page
                            >
                              <option [selected]="currentPageLength == 10">
                                10
                              </option>
                              <option [selected]="currentPageLength == 30">
                                30
                              </option>
                              <option [selected]="currentPageLength == 50">
                                50
                              </option>
                              <option [selected]="currentPageLength == 100">
                                100
                              </option>
                              <option [selected]="currentPageLength == 500">
                                500
                              </option>
                              <option [selected]="currentPageLength == 1000">
                                1000
                              </option>
                            </select>
                            &nbsp;
                            <span> entries</span>
                          </div>
                        </div>
                      </div>

                      <table
                        *ngIf="forgedresults !=''"
                        class="
                          table
                          table-bordered
                          table-condensed
                          table-responsive-sm
                          table-responsive-md
                          table-responsive-lg
                          table-responsive-xl
                          nowrap
                        "
                        datatable
                        [dtOptions]="dtOptions"
                        width="100%"
                      >
                        <thead class="">
                          <tr>
                            <th scope="col">S/N</th>
                            <th scope="col">Appointment ID</th>
                            <th scope="col">Passenger Name</th> 
                            <th scope="col">Passport Number</th>
                            <th scope="col">Phone Number</th> 
                            <th scope="col">Date Of Birth</th>
                            <th scope="col">Address</th>
                            <th scope="col">Nationality</th>
                            <th scope="col">Action</th>
                            <th scope="col">Report by Mobile</th>
                          </tr>
                        </thead>
                        <tbody class="dashboard-bg-white"> 

                          <tr
                            *ngFor="
                              let passenger of forgedresults | paginate: config;
                              index as i
                            "
                          >
                            <th scope="row">
                              {{
                                config.itemsPerPage * (config.currentPage - 1) +
                                  i +
                                  1
                              }}
                            </th>
                            <td>{{ passenger.ctms_passenger_id }}</td>
                            <td>{{ passenger.last_name + " " + passenger.first_name }}</td> 
                            <td>{{ passenger.passport_no }}</td>
                            <td>{{ passenger.phone }}</td>
                            <td>{{ passenger.dob | date }}</td>
                            <td>{{ passenger.address_residential  }}</td>
                            <td>{{ passenger.nationality }}</td>
                            <td>
                              <button class="btn-view" (click)="viewResult(resultModal,passenger)" type="button">
                                <i class="fas fa-eye"></i>
                              </button>
                            </td>
                            <td><a  target="_blank" href="assets/image/forged.png"> <button class="btn-view"><i class="fas fa-eye"></i></button></a></td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="table-footer">
                        <div
                          id="page_info"
                          class="mt-3 record-show-text-bottom"
                          *ngIf="forgedresults !=''"
                        >
                          Showing
                          {{
                            (config.currentPage - 1) * config.itemsPerPage + 1
                          }}
                          - {{ config.currentPage * config.itemsPerPage }} of
                          {{ config.totalItems }} entries
                        </div>

                        <div
                          class="pagination paging-pull-right"
                          *ngIf="forgedresults!=''"
                        >
                          <pagination-controls
                            (pageChange)="pageChange($event)"
                            class="my-pagination mt-2 pagination-server"
                          >
                          </pagination-controls>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #resultModal let-modal>
  <div class="row">
    <div class="col-lg-12 mb-3">
      <div
        class="
          card-header
          col-lg-12
          heading_n_button_box
          header-dashboard-button-2
        "
      >
        <h3>Forged Result</h3>
        <button
          type="button"
          class="close-button" id="closeModal"
          (click)="modal.close('Save click')"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="card-body p-4">
        <form
          [formGroup]="resultForm" 
        >
          <div class="row">
            <div class="col-lg-8 offset-lg-2 col-md-12 col-sm-12">
              <div class="form-group row">
                <label for="appointmenId" class="col-md-4 col-form-label"
                  >Appointment ID</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="appointmentId"
                    name="appointmentId"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="fullname" class="col-md-4 col-form-label"
                  >Full name</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="fullname"
                    name=""
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="phone" class="col-md-4 col-form-label"
                  >Phone number</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="phone"
                    name=""
                  />
                </div>
              </div>

              <div class="form-group row">
                <label for="passportNumber" class="col-md-4 col-form-label"
                  >Passport Number</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="passportNumber"
                    name=""
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="passportNumber" class="col-md-4 col-form-label"
                  >Address</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="address"
                    name=""
                  />
                </div>
              </div>

              <div class="form-group row">
                <label for="passportNumber" class="col-md-4 col-form-label"
                  >Occupation</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="occupation"
                    name=""
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="col-md-4 col-form-label"
                  >Email</label
                >
                <div class="col-md-8">
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    formControlName="email"
                    name=""
                  />
                </div>
              </div>

              <div class="form-group row">
                <label for="date" class="col-md-4 col-form-label">Status</label>
                <div class="col-md-8">
                  <select
                    class="form-control select-option"
                    name="status" disabled
                    formControlName="status"
                    id="status"
                  >
                    <option selected value="">Select Status</option>
                    <option value="FORGED">FORGED</option>
                    <option value="AUTHENTIC">AUTHENTIC</option>
                  </select>
 
                </div>
              </div>
 
            </div>
          </div>
        </form>
        <h5>Appointment Details</h5>
        <table
        *ngIf="appointmentDetails"
        class="
          table
          table-bordered
          table-condensed
          table-responsive-sm
          table-responsive-md
          table-responsive-lg
          table-responsive-xl
          nowrap
        " 
        width="100%"
      >
        <thead class="">
          <tr>
            <th scope="col">S/N</th>
            <th scope="col">Booking Date</th>
            <th scope="col">Booking Time</th>
            <!-- <th scope="col">Collection Center </th>  -->
            <th scope="col">Preferred State</th> 
            <!-- <th scope="col">LGA</th> -->
            <th scope="col">Expected State</th>
            <th scope="col">Expected City</th> 
          </tr>
        </thead>
        <tbody class="dashboard-bg-white"> 

          <tr
            *ngFor="
              let passenger of appointmentDetails ;
              index as i
            "
          >
            <th scope="row">
              {{ i + 1}}
            </th>
            <td>{{ passenger.booking_date | date }}</td>
            <td>{{ passenger.booking_time}}</td>  
            <!-- <td>{{ getCollectionCenters(passenger.center_id)}}</td>   -->
            <td>{{ passenger.prefer_state ?passenger.prefer_state : 'N/A' }}</td>
            <td>{{ passenger.lga_code_id }}</td>
            <!-- <td>{{ passenger.lga_code_id  == null ? 'N/A' : getLgas(passenger.lga_code_id)}}</td> -->
            <td>{{ passenger.expected_state ? passenger.expected_state : 'N/A'}}</td>
            <td>{{ passenger.expected_city ? passenger.expected_city : 'N/A'}}</td>
            
          </tr>
        </tbody>
      </table>
      <h5>Travel Details</h5>
      <table
      *ngIf="travelDetails"
      class="
        table
        table-bordered
        table-condensed
        table-responsive-sm
        table-responsive-md
        table-responsive-lg
        table-responsive-xl
        nowrap
      " 
      width="100%"
    >
      <thead class="">
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Travel Type</th>
          <th scope="col">Departure Country</th>
          <!-- <th scope="col">Departure State</th> -->
          <th scope="col">Departure Date</th>
          <th scope="col">Returning Date</th> 
          <th scope="col">Arrival Country</th> 
          <th scope="col">Arrival State</th>
          <th scope="col">Arrival Date</th>
          <th scope="col">Transit Country</th>
          <!-- <th scope="col">Airline</th>  -->
        </tr>
      </thead>
      <tbody class="dashboard-bg-white"> 

        <tr
          *ngFor="
            let passenger of travelDetails ;
            index as i
          "
        >
          <th scope="row">
            {{ i + 1}}
          </th>
          <td>{{ passenger.type == 2 ? 'INBOUND' : 'OUTBOUND'}}</td> 
          <td>{{ passenger.departure_country == null ? 'N/A' : passenger.departure_country }}</td>
          <!-- <td>{{ passenger.departure_state == null ? 'N/A' : passenger.departure_state }}</td> -->
          <td>{{ passenger.departure_date == null ? 'N/A' : passenger.departure_date | date }}</td>
          <td>{{ passenger.return_date  == null ? 'N/A' : passenger.return_date | date }}</td>
          <td>{{ passenger.arrival_country  == null ? 'N/A' : passenger.arrival_country }}</td>
          <td>{{ passenger.arrival_state  == null ? 'N/A' : passenger.arrival_state }}</td>
          <td>{{ passenger.arrival_date  == null ? 'N/A' : passenger.arrival_date | date }}</td>
          <td>{{ passenger.transit_country  == null ? 'N/A' : passenger.transit_country  }}</td>
          <!-- <td>{{ passenger.airline  == null ? 'N/A' : getAirline(passenger.airline) }}</td> -->
          
        </tr>
      </tbody>
    </table>
    

    <div class="form-group row">
      <div class="col-md-12 text-center">
        <div class="col-md-12">
           <!-- <button
            type="submit"
            class="btn btn-primary theme-btn ml-2"
          >
            Submit
          </button> -->

          <button
            type="button"
            class="btn btn-primary theme-btn ml-2 btn-red"
            (click)="modal.close('Save click')"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewStatusModal let-modal>
  <div class="card col-lg-12 mb-5">
    <div class="card-body p-4">
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <div>
            <h3 class="text-success mb-5">Uploaded successfully</h3>
          </div>

          <button
            type="button"
            class="btn btn-secondary ml-5" 
          >
            Next Passenger
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-footer-dashboard></app-footer-dashboard>
